"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrMediaGallerySkeleton = void 0;
const react_1 = __importDefault(require("react"));
const components_common_placeholder_loader_1 = require("@hotelplan/components.common.placeholder-loader");
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const MARGIN = 20;
const TITLE_HEIGHT = 20;
const FdrMediaGallerySkeleton = props => {
    const { uniqueKey, height, className } = props;
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    const viewportHeight = height + 20 + 20;
    return (react_1.default.createElement(components_common_placeholder_loader_1.PlaceholderLoader, { className: className, uid: uniqueKey, width: mobile ? 375 : 1170, height: viewportHeight, style: {
            width: '100%',
            height: viewportHeight,
        } }, mobile ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("rect", { x: "7", y: "226", width: "78", height: "13", rx: "6.5" }),
        react_1.default.createElement("rect", { x: "334", y: "226", width: "31", height: "13", rx: "6.5" }),
        react_1.default.createElement("rect", { width: "375", height: "213" }))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("rect", { width: "1170", height: `${viewportHeight - MARGIN - TITLE_HEIGHT}` }),
        react_1.default.createElement("rect", { y: `${viewportHeight - TITLE_HEIGHT}`, width: "230", height: "20", rx: "9" }),
        react_1.default.createElement("rect", { x: "1087", y: `${viewportHeight - TITLE_HEIGHT}`, width: "64", height: "20", rx: "9" })))));
};
exports.FdrMediaGallerySkeleton = FdrMediaGallerySkeleton;
//# sourceMappingURL=fdr-media-gallery-skeleton.js.map